<template>
  <div class="login-container">
    <div class="background-image"></div>
    <div class="login-form">
      <div class="lang">
        <img class="lang" :src="require('@/assets/common/langen.png')" alt="" @click="changeLang" v-if="lang=='zh'">
        <img class="lang" :src="require('@/assets/common/langzh.png')" alt="" @click="changeLang" v-else>
      </div>
      <div class="logo-header">
        <el-image
          class="logo-img"
          :src="require('@/assets/logo_new.png')"
          fit="contain"
        ></el-image>
      </div>
      <div class="brand-copy">
        <div class="brand-slogan">{{ $t('login.index.brandSlogan') }}</div>
        <div class="brand-desc">{{ $t('login.index.brandDesc') }}</div>
        <div class="brand-meta">
          <span>{{ $t('login.index.assistant247') }}</span>
          <span>{{ $t('login.index.poweredByEva') }}</span>
        </div>
      </div>
      <div class="form-panel">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item :label="$t('login.index.account')" prop="username">
            <el-input v-model="ruleForm.username" prefix-icon="el-icon-user" clearable :placeholder="$t('login.index.placeholder.inputAccount')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('login.index.password')" prop="password">
            <el-input v-model="ruleForm.password" type='password' prefix-icon="el-icon-lock" show-password autocomplete="off" :placeholder="$t('login.index.placeholder.inputPassword')"></el-input>
          </el-form-item>
          <div class="no-pass">
            <span class="no-pass-btn" @click="formVisible = true">{{ $t('login.index.forgetPassword') }}</span>
            <span class="no-pass-btn" @click="goregister">{{ $t('login.index.registerAccount') }}</span>
          </div>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%">{{ $t('login.index.login') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div class="x-tips">CTS GLOBAL SUPPLY CHAIN SOLUTIONS</div> -->
    <!-- 忘记密码 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('login.index.forgetPasswordTitle')"
      append-to-body
      :visible.sync="formVisible"
      width="500px"
      :before-close="closeDialog"
    >
      <Pass
        class="forgot-pass-form"
        v-if="formVisible"
        @ok="resetSuccess"
      />
    </el-dialog>
  </div>
</template>

<script>
import { usersLogin } from '@/api/login'
// import { usersLogin } from '@/api/ltl/login'
import Pass from './components/pass.vue';
import { mapActions } from 'vuex';
export default {
  components: {
    Pass
  },
  data() {
    return {
      formVisible: false,
      lang: window.localStorage.getItem('lhkdLang') || 'en',
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: this.$t('login.index.requiredMessage.account'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('login.index.requiredMessage.password'), trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    ...mapActions(['updateLang']),
    // 切换语言
    changeLang(){
      let current = window.localStorage.getItem('lhkdLang') || 'en'
      let lang = current == 'zh' ? 'en' : 'zh'
      this.$nextTick(() => {
        this.lang = lang
      })
    
      this.updateLang(lang);
    },
    goregister(){
      this.$router.push({ path: '/register'})
    },
    // 关闭
    closeDialog(){
      this.formVisible = false
    },
    // 密码重置成功后关闭弹窗
    resetSuccess(){
      this.formVisible = false
    },
    // 登录/注册
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          usersLogin(this.ruleForm).then(res => {
            if(res.code == 1){
              window.localStorage.setItem("userInfo1",JSON.stringify(res.data.userinfo)) //cts
              // window.localStorage.setItem("userInfo1",JSON.stringify(res.data))  // ltl
              this.$message.success(res.msg)
              if(this.$route.path != '/ltl/index'){
                this.$router.push({ path: '/ltl/index'});
              }
            }else{
              this.$message.error(res.msg)
            }
          })
        } else {
          return false;
        }
      });
    },
    // 临时注册
    linshi(){
      let data = {
        address: "1212",
        district: "长安区",
        email: "1@1.com",
        id: 69,
        nickname: "178****5718",
        phone: "12345678900",
        province: "河北省",
        sex: 1,
        usernames: "vr",
        zip_code: "1231321"
      }
      window.localStorage.setItem("userInfo1",JSON.stringify(data))
      this.$router.push({ path: '/bill/place'});
    }
  },
};
</script>

<style lang='scss' scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
}

.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #0a1f4d;
  background-image: url("~@/assets/bg_wide.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.login-form {
  width: 460px;
  z-index: 99;
  box-sizing: border-box;
  padding: 18px 30px 24px;
  // 蓝色玻璃拟态主体背景
  background: rgba(90, 150, 230, 0.30);
  // 背景模糊
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border-radius: 24px;
  // 很淡的白色描边
  border: 1px solid rgba(255, 255, 255, 0.5);
  // 蓝色发光阴影
  box-shadow: 0 0 50px rgba(120, 180, 255, 0.55), inset 0 0 36px rgba(255, 255, 255, 0.14);
  position: relative;

  .lang {
    position: absolute;
    right: 14px;
    top: 14px;
    z-index: 88;
    width: 22px;
    height: 22px;
    cursor: pointer;
  }

  // logo 顶部区域
  .logo-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 0 18px;
    .logo-img {
      width: 420px;
      height: 126px;
      // 将深色 logo 转为纯白，匹配参考图
      /deep/ img {
        filter: brightness(0) invert(1);
      }
    }
  }

  // 输入区面板：稍亮的内层玻璃
  .brand-copy {
    margin: -10px 0 16px;
    color: #ffffff;
    text-align: center;
  }

  .brand-slogan {
    font-size: 16px;
    font-weight: 600;
  }

  .brand-desc {
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.86);
    font-size: 13px;
  }

  .brand-meta {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 5px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 12px;
  }

  .form-panel {
    background: rgba(255, 255, 255, 0.22);
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.35);
    padding: 18px 20px 6px;
  }

  .demo-ruleForm {
    width: 100%;
  }
}

// 表单标签：白色，置于输入框上方，靠左对齐
/deep/.el-form-item__label {
  color: #ffffff !important;
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 6px !important;
  line-height: 1.4;
  text-align: left !important;
  width: 100% !important;
  float: none !important;
  display: block;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
// 隐藏必填项红色星号
/deep/.el-form-item.is-required .el-form-item__label:before {
  display: none !important;
}
// 校验错误提示：醒目颜色，避免被下一项遮挡
/deep/.el-form-item__error {
  color: #ffd54a;
  font-size: 13px;
  padding-top: 2px;
}

// 输入框：浅白色高不透明，圆角，清晰可见
/deep/.el-input__inner {
  height: 44px;
  line-height: 44px;
  background: rgba(255, 255, 255, 0.9) !important;
  border: none !important;
  border-radius: 12px !important;
  padding-left: 44px !important;
  // 文字深蓝灰色
  color: #2c3e54 !important;
  font-size: 15px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
}
/deep/.el-input__inner::placeholder {
  color: #8a99ab !important;
}
// 输入框内前缀图标
/deep/.el-input__prefix {
  left: 12px;
  display: flex;
  align-items: center;
}
/deep/.el-input--prefix .el-input__prefix .el-input__icon,
/deep/.el-input__prefix .el-input__icon {
  font-size: 20px;
  color: #1a2a5e !important;
  line-height: 44px;
}
/deep/.el-input__icon {
  font-size: 18px;
  color: #1a2a5e !important;
  line-height: 44px;
}
// 密码显隐眼睛图标放大
/deep/.el-input__suffix {
  right: 12px;
}
/deep/.el-input__suffix .el-input__icon {
  font-size: 22px;
  color: #1a2a5e !important;
}

// 登录按钮：深亮蓝色，强化视觉焦点
/deep/.el-button--primary {
  height: 46px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 1px;
  background-color: #0a52d8 !important;
  border-color: #0a52d8 !important;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(10, 82, 216, 0.5);
}
/deep/.el-button--primary:hover {
  background-color: #0843b5 !important;
  border-color: #0843b5 !important;
}

.no-pass {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
  margin-top: -4px;
  .no-pass-btn {
    line-height: 24px;
    font-size: 15px;
    cursor: pointer;
    color: #bfe0ff;
    text-decoration: underline;
  }
}

// 忘记密码弹窗使用 Element UI 默认表单尺寸，避免继承登录页的玻璃表单样式
/deep/.forgot-pass-form .el-form-item__label {
  display: block;
  float: left !important;
  width: 140px !important;
  padding: 0 12px 0 0 !important;
  color: #606266 !important;
  font-size: 14px;
  font-weight: normal;
  line-height: 32px;
  text-align: right !important;
}
/deep/.forgot-pass-form .el-input__inner {
  height: 32px;
  padding: 0 15px !important;
  color: #606266 !important;
  font-size: 13px;
  line-height: 32px;
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  box-shadow: none;
}
/deep/.forgot-pass-form .el-input-group--append .el-input__inner {
  border-radius: 4px 0 0 4px !important;
}
/deep/.forgot-pass-form .el-input-group__append {
  padding: 0 20px;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-left: 0;
  border-radius: 0 4px 4px 0;
  box-shadow: none;
}
/deep/.forgot-pass-form .el-button--primary {
  height: 32px;
  padding: 9px 15px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 3px;
  box-shadow: none;
}
</style>
